import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
    IUniqLink,
    IUniqLinkState,
    IUniqLinkSearchForm,
} from 'types/uniq-link';

const initialState: IUniqLinkState = {
    uniqLinks: [],
    uniqLink: null,
    uniqLinksSearchForm: {
        searchKeyWord: '',
        startDate: '',
        endDate: '',
    },
};

const uniqLinkSlice = createSlice({
    name: 'uniqLink',
    initialState,
    reducers: {
        setUniqLinks: (state, action: PayloadAction<IUniqLink[]>) => {
            state.uniqLinks = action.payload;
        },
        setUniqLink: (state, action: PayloadAction<IUniqLink | null>) => {
            state.uniqLink = action.payload;
        },
        setUniqLinkSearchForm: (
            state,
            action: PayloadAction<IUniqLinkSearchForm>
        ) => {
            state.uniqLinksSearchForm = {
                ...state.uniqLinksSearchForm,
                ...action.payload,
            };
        },
        clearUniqLinkSearchForm: (state) => {
            state.uniqLinksSearchForm = initialState.uniqLinksSearchForm;
        },
    },
});

export const {
    setUniqLinks,
    setUniqLink,
    clearUniqLinkSearchForm,
    setUniqLinkSearchForm,
} = uniqLinkSlice.actions;

export default uniqLinkSlice.reducer;
